import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container home-page">
      <div className="profile-section">
        <img src="https://i.pinimg.com/736x/c5/b4/a8/c5b4a8e69cb8374ff1217c37ee45d3c7.jpg" alt="Profile" className="profile-photo" />
        <h1>Hi, I'm Anish</h1>
        <p>
          I am a passionate React Developer creating interactive and dynamic web applications.
          Welcome to my portfolio!
        </p>
        <button onClick={() => navigate('/projects')} className="cta-button">
          View Projects
        </button>
      </div>
    </div>
  );
};

export default Home;